<div *ngIf="visivel" class="confirmacao-ponto-backdrop" role="status" aria-live="assertive">
  <div class="confirmacao-ponto-card">
    <div class="confirmacao-ponto-titulo">{{ titulo }}</div>
    <div class="confirmacao-ponto-nome">{{ nome }}</div>
    <div *ngIf="horario" class="confirmacao-ponto-horario">{{ horario }}</div>
  </div>
</div>
